import { execOnLoad } from '@general/helpers';
import './product-recommendations.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductRecommendations = async (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const wrapper = sectionContainer.querySelector(
    '.product-recommendations__container',
  );
  if (wrapper) {
    const productId = wrapper?.dataset?.productId;
    if (productId)
      await fetch(
        `${window.Shopify.routes.root}recommendations/products?product_id=${productId}&limit=12&intent=related&section_id=product-recommendations`,
      )
        .then((res) => res.text())
        .then((data) => {
          const sectionDom = new DOMParser().parseFromString(data, 'text/html');
          const newWrapper = sectionDom.querySelector(
            '.product-recommendations__container',
          );
          if (newWrapper) wrapper.innerHTML = newWrapper.innerHTML;

          const carouselContainer = wrapper.querySelector(
            '.carousel__container',
          );
          if (
            carouselContainer &&
            typeof window.dAgency.initCarousel == 'function'
          )
            window.dAgency.initCarousel(carouselContainer);

          if (typeof window.dAgency.initProductTile == 'function')
            wrapper
              .querySelectorAll('.product-tile__container')
              .forEach((tile) => window.dAgency.initProductTile(tile));
        });
  }
};

execOnLoad(
  window.dAgency.initProductRecommendations,
  '.product-recommendations__section',
);
